import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Splash_Page from "./Components/PublicForms/Splash_Page.js";
import Analysis from "./Components/Dashboards/Analysis.js";
import Login from "./Components/Identity/Login";
import PersonList from "./Components/Persons/PersonList";
import SubDetailsLst from "./Components/Subscript/SubDetailsLst";
import Not_Found from "./Components/PublicForms/Not_Found.js";
import Preview_Person from "./Components/Persons/Preview_Person.js";
import ProvinceList from "./Components/Settings/ProvinceList.js";
import CityList from "./Components/Settings/CityList.js";
import Preview_Province from "./Components/Settings/Preview_Province.js";
import Preview_City from "./Components/Settings/Preview_City.js";
import Preview_Report from "./Components/Dashboards/Report/Preview_Report.js";
import Pree_Pdf_Report_All_Subscript from "./Components/Dashboards/Report/Pree_Pdf_Report_All_Subscript.js";
import Pree_Pdf_Report_All_Person from "./Components/Dashboards/Report/Pree_Pdf_Report_All_Person.js";
import Preview_SubDetails from "./Components/Subscript/Preview_SubDetails.js";
import Pree_Pdf_Post from "./Components/Dashboards/Report/Pree_Pdf_Post.js";
import Preview_One_Post from "./Components/Subscript/Preview_One_Post.js";
import Pree_Pdf_One_Post from "./Components/Subscript/Pree_Pdf_One_Post.js"

const Routing = ({ location }) => {

  
  
   
    return (
      <BrowserRouter>
         <Routes>
          <Route path ="/" exact element = {<Splash_Page />} />   
          <Route path ="/Login" exact element = {<Login />} />

          <Route path="/dashboard/analysis/:section/:category" exact element = {
            <Analysis
            />} />
          <Route path="/dashboard/reports/:section/:category" exact element = {
            <Preview_Report/>
            } />

          <Route path="/printAllPersons/:degree/:province/:city" exact element = {
          <Pree_Pdf_Report_All_Person/>}/>

          <Route path="/printAllSubscript/:remain/:degree/:province/:city" exact element = {
              <Pree_Pdf_Report_All_Subscript />
            }/>

            <Route path="/post/:number/:cost/:numberJeld" exact element = { 
              <Pree_Pdf_Post />
            }
            />
            <Route path="/onePost/:subscriptID/:number/:cost/:numberJeld" exact element = { 
              <Pree_Pdf_One_Post />
             }
            />

          <Route path ="/persons/lstPersons/:section/:category" exact element = {
               <PersonList />
              } />
          <Route path ="/persons/previewPersons/:section/:category/:personID" exact element = {
                <Preview_Person />
               } />

          <Route path="/subscripts/lstSubscripts/:section/:category/:personID/:subscript/:print" exact element = {
            <SubDetailsLst />
          } />

          <Route path ="/subscripts/previewSubscript/:section/:category/:personID/:subscriptID/:subscript/:print" exact element = {
            <Preview_SubDetails />
            } />
          
          <Route path ="/subscripts/printSubscript/:section/:category/:personID/:subscriptID/:subscript/:print" exact element = {
            <Preview_One_Post />
            } />
          
          <Route path="/settings/lstProvinces/:section/:category" exact element ={<ProvinceList />} />

          <Route path="/settings/lstCities/:section/:category" exact element ={<CityList />} />

          <Route path="/settings/previewProvinces/:section/:category/:id" exact element ={<Preview_Province />}
           />
          <Route path="/settings/previewCity/:section/:category/:id" exact element ={<Preview_City />} />
            
         
           <Route path="*" exact element = { 
            <Not_Found />        
          } />    
         </Routes>
      </BrowserRouter>
    )
  }
  
  export default Routing;
  
